<template>
	<el-dialog title="新增巡检点" :visible.sync="dialogFormVisible" width="460px" :center="true">
        <el-form :model="formNew" ref="formNew" label-width="110px" class="demo-form-inline" size="small">
          <el-form-item label="所属用户/组织" :label-width="formLabelWidth" prop="parent">
            <el-input v-model="formNew.parent" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="卡编号" :label-width="formLabelWidth" prop="patrol_sn">
            <el-input v-model="formNew.patrol_sn" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="巡检点名称" :label-width="formLabelWidth" prop="patrol_name">
            <el-input v-model="formNew.patrol_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="位置" :label-width="formLabelWidth" prop="location">
            <el-input type="textarea" v-model="formNew.location"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" v-model="formNew.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="SavePatrolCardInfo()" size="small">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Api from '../../api/index'

export default {
  name: "PatrolCardForm",
  data() {
    return {
        dialogFormVisible: false,
        formLabelWidth: '110px',
        object_type_options: [
            {
              value: 1,
              label: 'T80'
            }
        ],
        displayPassword: true,
        parent_id: 0,
        formNew: {
          patrol_id: 0,
          parent: "",
          patrol_sn: "",
          patrol_name: "",
          location: "",
          remark: ""
        }
    }
  },
  methods: {
    show: function(id, parent_id) {
        this.dialogFormVisible = true;
        if(id > 0) {
          // id > 0时parent_id无参考意义
          this.displayPassword = false;
          Api.GetPatrolCardDetail({ patrol_id: id }).then(res => {
            if(!res)
              return;

            if(res.code !== 200) {
              this.$message.error(res.msg);
            }

            if(res.data) {
              this.parent_id = res.data.hold_id;
              this.formNew.patrol_id = res.data.patrol_id;
              this.formNew.patrol_sn = res.data.patrol_sn;
              this.formNew.patrol_name = res.data.patrol_name || "";
              this.formNew.location = res.data.location || "";
              this.formNew.remark = res.data.remark || "";

              Api.LoadParentBase({ id: res.data.hold_id }).then(res2 => {
                if(!res2 && res2.code !== 200)
                  return;

                if(res2.data) {
                  this.formNew.hold_id = res2.data.hold_id;
                  this.formNew.parent = res2.data.hold_name;
                }
              });
            }
          }).catch(err => {
              this.$message.error('错了哦，接口出错！' + err);
          });
        } else {
          this.displayPassword = true;
          this.formNew.hold_id = 0;
          this.parent_id = parent_id;
          this.formNew.patrol_id = 0;
          this.formNew.patrol_sn = "";
          this.formNew.patrol_name = "";
          this.formNew.location = "";
          this.formNew.remark = "";

          Api.LoadParentBase({ id: this.parent_id }).then(res => {
            if(!res && res.code !== 200)
              return;

            if(res.data) {
              this.formNew.hold_id = res.data.hold_id;
              this.formNew.parent = res.data.hold_name;
            }
          });
        }
    },
    SavePatrolCardInfo: function() {
      if(this.formNew.hold_id < 1) {
        this.$message.error('数据异常，无法保存！');
        return;
      }
      if(this.formNew.patrol_sn.length === 0) {
         this.$message.error('请输入卡编号！');
         return;
      }
      
      var argdata = {
        patrol_id: this.formNew.patrol_id,
        hold_id: this.formNew.hold_id,
        patrol_sn: this.formNew.patrol_sn,
        patrol_name: this.formNew.patrol_name,
        location: this.formNew.location,
        remark: this.formNew.remark
      };
      Api.SavePatrolCardInfo(argdata).then(res => {
        if(!res) {
          this.$message.error('出错了！');
          return;
        }

        if(res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }

        console.log(res);

        this.$message({
          message: '恭喜你，提交成功！',
          type: 'success'
        });

        this.$emit("eventRefreshTableName");
        this.dialogFormVisible = false;
      });
    }
  }
}
</script>